import styled from '@emotion/styled';

export const AdminUsersWrapper = styled('div', { label: 'AdminUsersWrapper' })`
    display: flex;
    flex-flow: column nowrap;
    flex: 1 1 0%;
`;

export const AdminUsersTopMenu = styled('div', { label: 'AdminUsersTopMenu' })`
    flex: 0 0 44px;
`;

export const AdminUsersContentWrapper = styled('div', { label: 'AdminUsersContentWrapper' })`
    display: flex;
    flex-flow: row nowrap;
    flex: 1 1 0%;
    position: relative;
`;

export const AdminUserContentLhs = styled('nav', { label: 'AdminUserContentLhs' })`
    background: #fff;
    display: flex;
    flex-flow: column nowrap;
    flex: 0 0 25%;
    height: calc(100vh - 148px);
    width: 25%;
`;

export const AdminUserContent = styled('div', { label: 'AdminUserContent' })`
    flex: 1 1 0%;
    height: calc(100vh - 148px);
    margin-left: 5px;
    overflow: hidden auto;
    position: relative;
    width: auto;
`;

export const AdminUserSearchInputWrapper = styled('div', { label: 'AdminUserSearchInputWrapper' })`
    flex: 0 0 48px;
    padding: 10px;
`;

export const AdminUserSearchInput = styled('input', { label: 'AdminUserSearchInput' })`
    border-radius: 4px;
    border: 1px solid #666;
    padding: 5px 10px;
    width: 100%;
`;
